export default __webpack_public_path__ + "static/media/theampitheatreofkarutoniaunchained.3e6a963c.jpg";